import { render, staticRenderFns } from "./UserProfileViewProjects.vue?vue&type=template&id=39fa353f"
import script from "./UserProfileViewProjects.vue?vue&type=script&lang=js"
export * from "./UserProfileViewProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports